import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import Table from "../../Components/ActivityLogs/Table";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
  FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";

import { useSelector } from "react-redux";
import moment from "moment";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import { toast } from "react-toastify";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";

const ActivityLogs = () => {
  const searchOptions = [
    { label: "Done By", value: 1 },
    { label: "Activity", value: 2 },
  ];
  const { t, i18n } = useTranslation();
  const user = useSelector((state) => state.UserReducer.user);
  const [filterValue, setFilterValue] = useState("");
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [apiData, setApiData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const properties = useSelector((state) => state.PropertyReducer.property);

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [selectedProperty, setSelectedProperty] = useState(property);


  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  let query = `&startDate=${startDate}&endDate=${endDate}&propId=${selectedProperty?.id}`;
  query += `&s=${searchQuery}&t=${filterType}`;
  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/activity-log/list?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [property, startDate, endDate, filterType, searchQuery, selectedProperty]);
  // useEffect(() => {
  //   if (filterValue) {
  //     const handler = setTimeout(() => {
  //       getListMutate();
  //     }, 500);

  //     return () => {
  //       clearTimeout(handler);
  //     };
  //   }
  // }, [filterValue, startDate, endDate]);

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     getListMutate();
  //   }, 500);

  //   return () => {
  //     clearTimeout(handler);
  //   };
  // }, [property]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
  };

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
  };

  const downloadQuery = `&startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}&propId=${property?.id
    }&fileType=${1}&reportType=${9}`;
  const [reportUrl, setReportUrl] = useState();

  useEffect(() => {
    if (reportUrl) {
      const link = document.createElement("a");
      link.href = reportUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setReportUrl(null);
    }
  }, [reportUrl]);

  const downloadFunction = async (values) => {
    const response = await axios.get(
      `${Config.apiUrl}/report/generate?${downloadQuery}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onDownloadSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "No data found for the selected date range");
    } else if (res.reportUrl === false) {
      toast.error("No data found for the selected date range");
    } else {
      setReportUrl(res.reportUrl);
      toast.success(res.msg || "Report generated successfully");
    }
  };

  const onDownloadError = (res) => {
    toast.error(res.message || "Failed to download report");
  };

  const {
    mutate: downloadReport,
    isLoading: isDownloading,
    error: reportError,
  } = useMutation(downloadFunction, {
    onSuccess: onDownloadSuccess,
    onError: onDownloadError,
  });

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Activity Logs
          <Underline />
        </BoxTitle>
        <DownloadBtn type="button" onClick={() => downloadReport()}>
          {isDownloading ? "Downloading..." : "Download"}
        </DownloadBtn>
      </BoxHead>

      <FilterTableWrapper>
        <FilterWrapperWithSearch>
          <div className="flex flex-col md:flex-row md:items-center lg:space-x-4 gap-4">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
            <DateRange
              submitHandler={submitHandler}
              defaultLabel={
                moment(startDate).format("DD MMM yyyy") +
                " - " +
                moment(endDate).format("DD MMM yyyy")
              }
            />
          </div>
          <div className="w-full md:w-auto">
            <PropertiesFilterDropdown
              properties={properties}
              selectedProperty={selectedProperty}
              onPropertySelect={handlePropertySelect}
              placeholder="Select Property"
              className="min-w-[200px] w-full md:w-[220px]"
            // className="min-w-[200px]"
            />
          </div>
          {/* <DownloadBtn type="button" onClick={() => downloadReport()}>
                  {isDownloading ? "Downloading..." : "Download"}
                </DownloadBtn> */}
        </FilterWrapperWithSearch>
        {!error && !isLoading && apiData && (
          <TableWrapper>
            <Table apiData={error ? [] : apiData} />
            {(error || (apiData && apiData.length === 0)) && !isLoading && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
// const FilterWrapper = tw.div`flex w-full lg:flex-row flex-col lg:gap-0 gap-4`;
const DownloadBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-2.5 text-sm`;
export default ActivityLogs;
